export default "__VITE_ASSET__NF_XKqjM__"